<template>
  <div id="home">
    <el-backtop target=""></el-backtop>
    <Video />
    <Nosotros v-if="true" id="" />
    <Desarrollo v-if="true" id="" />
    <Cultura v-if="true" id="" />
    <Social v-if="true" id="" />
    <Beneficios v-if="true" id="" />
    <Comercial v-if="true" id="prensa" />
    <Footer id="footer"></Footer>
    <!-- <Footer id="contacto"></Footer> -->
    <el-row
      ><el-col
        ><h6 class="footer-final">
          <center>{{ altEmpresa }}</center>
        </h6></el-col
      ></el-row
    >
  </div>
</template>

<script>
import Video from '@/components/trabaja/principal_trabaja.vue'
import Nosotros from '@/components/trabaja/trabaja-nosotros-2.vue'
// import Calidad from '@/components/new/calidad.vue'
import Desarrollo from '@/components/trabaja/desarrollo.vue'
import Cultura from '@/components/trabaja/cultura.vue'
import Social from '@/components/trabaja/social.vue'
import Beneficios from '@/components/trabaja/beneficios.vue'
import Comercial from '@/components/trabaja/comercial-trabaja.vue'
// import Comercial from '@/components/new/comercial.vue'

import Footer from '@/components/footer.vue'

export default {
  components: {
    Video,
    Nosotros,
    Desarrollo,
    Cultura,
    Social,
    Beneficios,
    Comercial,
    Footer,
  },
  data() {
    return {
      altEmpresa: null,
      anio: new Date(),
    }
  },
  mounted() {
    this.altEmpresa = 'LOG-IN FARMA S.R.L © ' + this.anio.getFullYear()
    window.scrollTo(0, 0)
  },
}
</script>

<style lang="scss" scoped>
// Servicios // Servicios // import Servicios from "@/components/new/servicios.vue"
// import Infra from "@/components/new/infra.vue"; // import Galeria from "@/components/new/galeria.vue";
// import Mapa from "@/components/new/mapa.vue"; // import Contacto from "@/components/new/contacto.vue";
// , Infra, Galeria, Mapa, Contacto
.el-backtop {
  position: fixed;
  background-color: #bb643571;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgb(0 0 0 / 0%);
  cursor: pointer;
  z-index: 5;
}
.footer-final {
  color: #d35915;
  font-family: 'roboto-regular';
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .footer-final {
    font-size: 16px;
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .footer-final {
    font-size: 14px;
  }
}
@media (max-width: 375px) {
  .footer-final {
    font-size: 14px;
  }
}
</style>
